// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-askCompanyButton__subText":"jobSearchDetail-askCompanyButton__subText"};